import type {Editor} from 'grapesjs';
import type {Component} from 'grapesjs';
import {updateLinksColor} from '@EmailMakerReact/lib/email-maker-component-style-library';
import {updateCellsBackgroundColor, updateCellsBorderColor} from '@EmailMakerReact/lib/email-maker-table-style-library';
import type {ColorControlDescriptor} from './color-control.types';

export const textColorDescriptor: ColorControlDescriptor = {
  property: 'color',
  labelKey: 'pmwjs_text_color',
  isDeletable: false,
  isTextColor: true,
};

export const linkColorDescriptor: ColorControlDescriptor = {
  property: 'pmw-link-color',
  labelKey: 'pmwjs_link_color',
  isDeletable: false,
  onColorChange: (color: string, component: Component, _editor: Editor): void => {
    updateLinksColor(component, color);
  },
};

export const bgColorDescriptor: ColorControlDescriptor = {
  property: 'background-color',
  labelKey: 'pmwjs_background_color',
  isDeletable: true,
};

/**
 * Defaults to black, not white: an unset border-color renders as the element's `currentColor`
 * (≈ black), so the swatch must show black to match the canvas for borders with no explicit color.
 */
export const borderColorDescriptor: ColorControlDescriptor = {
  property: 'border-color',
  labelKey: 'pmwjs_color',
  isDeletable: true,
  defaultColor: '000000',
};

export const cellsBgColorDescriptor: ColorControlDescriptor = {
  property: 'pmw-cell-background-color',
  labelKey: 'pmwjs_color',
  defaultColor: 'FAFAFA',
  onColorChange: (color: string, _component: Component, editor: Editor): void => {
    updateCellsBackgroundColor(editor, color);
  },
};

export const cellsBorderColorDescriptor: ColorControlDescriptor = {
  property: 'pmw-cell-border-color',
  labelKey: 'pmwjs_border_color',
  isDeletable: true,
  defaultColor: '242424',
  onColorChange: (color: string, _component: Component, editor: Editor): void => {
    updateCellsBorderColor(editor, color);
  },
};

export const emailBgColorDescriptor: ColorControlDescriptor = {
  property: 'background-color',
  labelKey: 'pmwjs_email_background',
  isDeletable: false,
  noteKey: 'pmwjs_email_background_desktop_note',
};

export const contentBgColorDescriptor: ColorControlDescriptor = {
  property: 'background-color',
  labelKey: 'pmwjs_content_background',
  isDeletable: true,
};
